import { LockOutlined, MailOutlined, UnlockOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Col, Divider, Form, Input, Row, Spin, message } from "antd";
import { useEffect, useState } from "react";

import Title from 'antd/lib/typography/Title';
import { Api } from "contexts/api";
import { useAuth } from "contexts/useAuth";
import { BiArrowBack } from 'react-icons/bi';

const style = {
  backgroundColor: '#fff',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
}

export const LoginForm = (props) => {

  const {
    extra,
    loading,
    rememberMe
  } = props;

  const [forget, setForget] = useState({
    state: false,
    email: null,
    token: null,
  });

  const [loadingForget, setLoadingForget] = useState(false);


  const auth = useAuth();

  const onLogin = (fields) => {
    auth.login(fields.email, fields.password, remember);
  };

  const onForget = (fields) => {
    setLoadingForget(true)
    const status = auth.forget(fields.email);
    Promise.resolve(status).then(res => {

      if (res) {
        message.success('Um codigo de verificação foi enviado para seu email')
        setForget({ ...forget, email: fields.email })
      }
      setLoadingForget(false)
    })
  }

  const onForgetPassword = () => {
    setForget({ ...forget, state: true });
  }


  const onToken = async ({ token }) => {
    setLoadingForget(true)
    try {
      const { status } = await Api.post('/validate-token', { email: forget.email, token },
        {
          headers: {
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
          },
        });

      status === 200 && setForget({ ...forget, token })
    } catch (error) {

      console.log(error);
    }

    setLoadingForget(false)

  }

  const onResetPassword = async ({ password, password_confirmation }) => {
    setLoadingForget(true)
    try {
      const { data } = await Api.post('/reset-password', { ...forget, password, password_confirmation },
        {
          headers: {
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
          },
        });

      onLogin({ email: forget.email, password })
      setForget({ state: false, email: null, token: null })

    } catch (error) {
      console.log(error);
    } 

    setLoadingForget(false)


  }

  const ResetPasswordPage = () => {

    const [form] = Form.useForm();

    return (
      <Form
        layout="vertical"
        name="login-form"
        onFinish={onResetPassword}
        form={form}
      >
        <Form.Item
          name="password"
          label={<span>Senha</span>}
          rules={[
            {
              required: true,
              message: 'Por favor confirme sua senha',
            },
            () => ({
              validator(_, value) {
                if (value.length > 8) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('A senha deve ter mais que 8 caracteres'));
              },
            }),
          ]}
          hasFeedback

        >
          <Input.Password
            size={'large'}
            className='inputs'
            prefix={<UnlockOutlined className="text-primary" />}
            placeholder='Senha'

          />


        </Form.Item>
        <Form.Item
          name="password_confirmation"
          label={<span>Confirmar Senha</span>}
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Por favor confirme sua senha',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('As duas senhas não correspondem'));
              },
            }),
          ]}
        >
          <Input.Password
            size={'large'}
            className='inputs'
            prefix={<UnlockOutlined className="text-primary" />}
            placeholder='Senha'
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" className="login-button" htmlType="submit" block loading={loadingForget}>
            Confirmar
          </Button>
        </Form.Item>
      </Form>
    )
  }


  const TokenPage = () => {
    return (
      <Form
        layout="vertical"
        name="login-form"
        onFinish={onToken}
      >
        <Form.Item
          name="token"
          label="Token"
        >
          <Input
            className='inputs'
            prefix={<LockOutlined />}
            placeholder="Token"
            size={'large'}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" className="login-button" htmlType="submit" block loading={loadingForget}>
            Enviar código
          </Button>
        </Form.Item>
      </Form>
    )
  }


  const ForgetPage = () => {
    return (
      <Form layout="vertical"
        name="login-form" onFinish={onForget}>
        <p className="forget-password-text">
          Por favor, digite o email da sua conta para redefinir sua senha, em seguida você receberá um e-mail com instruções para redefinir sua senha.
        </p>
        <Divider />
        <Form.Item
          name="email"
          label="Email de recuperação"
          rules={[
            {
              required: true,
              message: "Por favor insira seu email",
            },
            {
              type: "email",
              message: "Por favor insira um email valido!",
            },
          ]}
        >
          <Input
            className='inputs'
            prefix={<MailOutlined className="text-primary" />}
            placeholder="Email"
            size={'large'}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" className="login-button" htmlType="submit" block loading={loadingForget}>
            Enviar
          </Button>
        </Form.Item>
      </Form>
    )
  }


  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {

    setTimeout(() => {
      setLoadingPage(true)
    }, 1000)

    return () => setLoadingPage(false)

  }, []);
  const [remember, setRemember] = useState(false);

  if (!loadingPage)
    return <Spin size="large" tip={'Carregando...'} style={{ position: 'absolute', top: '50%', left: '50%' }} />


  return (
    <div style={style} className={"login-page"}>
      <div className="image-container">
        <img src="/img/login/ArborSlogan.svg" alt="" />
        <div className="title-container">
          <Title className='title' level={1} >Bem vindo</Title>
          <p className='phrase'>
            Transforme o seu conhecimento com a ARBOR. <br />
            Faça login em sua conta e tenha acesso a nossa plataforma.
          </p>
        </div>
      </div>
      <div
        style={{
          width: '100%',
          maxWidth: '1400px',
          maxHeight: '100vh',
          padding: '0 20px',
        }}

      >
        <Row style={{ zIndex: 9999 }} justify="center" hidden={loading}>
          <Col className="main-column" span={20} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Card className="card">
              <div className="my-4">
                <div className="text-center">
                  <h2 className="title" style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'clamp(1.5rem, 5vw, 2rem)',
                  }}>
                    <UnlockOutlined /> {!forget.state ? 'Login' :

                      'Esqueceu sua senha?'
                    }
                    {forget.state &&
                      <div style={{ position: 'absolute', top: '4px', cursor: 'pointer', left: 0 }}
                        onClick={() => setForget({ state: false, email: null, token: null })}
                      >
                        <BiArrowBack />
                      </div>}
                  </h2>


                </div>
                <Row justify="center" style={{ transition: 'all 0.8s ease-in-out' }}>
                  <Col xs={24} sm={24} md={22} lg={22} >

                    {!forget.state ? (

                      <Form layout="vertical"
                        name="login-form" onFinish={onLogin}>

                        <Form.Item
                          name="email"
                          label="Email"
                          rules={[
                            {
                              required: true,
                              message: "Por favor insira seu email",
                            },
                            {
                              type: "email",
                              message: "Por favor insira um email valido!",
                            },
                          ]}
                        >
                          <Input
                            className='inputs'
                            prefix={<MailOutlined className="text-primary" />}
                            placeholder="Email"
                            size={'large'}
                          />

                        </Form.Item>

                        <Form.Item
                          className="mb-0"
                          name="password"
                          label={<span>Senha</span>}
                          rules={[
                            {
                              required: true,
                              message: "Por favor insira sua senha",
                            },
                          ]}
                        >
                          <Input.Password
                            size={'large'}
                            className='inputs'
                            prefix={<UnlockOutlined className="text-primary" />}
                            placeholder='Senha'
                          />
                        </Form.Item>

                        <div className="d-flex justify-content-start mt-4 mb-4" style={{ flexWrap: 'wrap' }}>
                          <Checkbox className="card-small-text" onChange={({ target }) => {
                            setRemember(target.checked)
                          }}>Lembrar-me</Checkbox>
                          <span
                            onClick={onForgetPassword}
                            className="card-small-text ml-auto"
                          >
                            Esqueceu a Senha?
                          </span>
                        </div>

                        <Form.Item>
                          <Button type="primary" className="login-button" htmlType="submit" block loading={auth.loading}>
                            Acessar
                          </Button>
                        </Form.Item>
                        {extra}
                      </Form>
                    ) : (
                      !forget.email ? <ForgetPage /> : (
                        !forget.token ? <TokenPage /> : <ResetPasswordPage />
                      )
                    )}
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div >
  );
};


export default LoginForm;
